import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { Input, Layout } from "../../components"

/* Swal */
import Swal from "sweetalert2"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Helpers */
import { utils, withRouter } from "../../helpers"

/* REST API */
import { get, edit } from "../../api/Card"

/* Translate */
import { t } from "../../translates/translate"



/* Page Card Edit */
class CardEdit extends Component {

    constructor() {
        super()

        this.state = {
            data: null,
            status: "loading",
            barcode: "",
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load action */
    load = (reload = false) => {

        const { params } = this.props
        const { id } = params

        if (id) {

            if (reload) {
                this.setState({ status: "loading" })
            }

            get({ id }).then((response) => {
                if (response.status === 200) {
                    const data = response.data
                    this.setState({
                        data,
                        barcode: utils.checkValue(data.barcode),
                        status: "ok",
                    })
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ status: "permission" })
                }
                else if (response.status === 498) {
                    this.setState({ status: "key" })
                }
                else {
                    this.setState({ status: "error" })
                }
            }).catch(() => {
                this.setState({ status: "network" })
            })
        }
        else {
            this.setState({ status: "error" })
        }

    }


    /* Save action */
    save = () => {

        const { barcode } = this.state
        const { navigate, params } = this.props
        const { id } = params

        if (!id) {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
            return
        }

        if (barcode === "") {
            this._barcode.error(t("card.error.emptyBarcode"))
            return
        }

        this.setState({ waiting: true })

        edit({ id, barcode }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("card.savedSuccess"), "success")).then(() => {
                    navigate(-1)
                })
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }


    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="button">{t("common.save")}</div>
    }


    render = () => {

        const { status, barcode } = this.state

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("card.editTitle")}</h1>
                </div>

                <div className="page-form">

                    <div className="form">
                        <div className="form-box">
                            <Input ref={(ref) => this._barcode = ref} label={t("card.barcode")} value={barcode} onChange={(event) => this.setState({ barcode: event.target.value })} />
                        </div>
                    </div>

                    <div className="form-bottom">
                        {this._button()}
                    </div>

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(withRouter(CardEdit))
